module.exports = __webpack_public_path__ + "static/media/state-banner-1.b8783434.png";